<template>
	<el-row class="points-show">
		<el-col :span="23">
			自定义字段
		</el-col>
		<el-divider></el-divider>
		<el-row :gutter="20">
			<el-col :span="5">
				<el-button type="success" size="mini" icon="el-icon-plus" @click="addCustom()">增加字段</el-button>
			</el-col>
		</el-row>
		<el-col :span="24">
			<!-- 数据列表 -->
			<el-table :data="customData" style="width: 100%" :height="tableHeight">
				<el-table-column prop="dicId" label="序号" width="65"> </el-table-column>
				<el-table-column prop="dicValue" label="字段名称" width="180"> </el-table-column>
				<el-table-column prop="dicType" label="字段类型"> </el-table-column>
				<el-table-column prop="created" label="创建日期"> </el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button size="mini" plain type="primary" @click="delCustomData(scope.row.dicId,1)">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total,prev, pager, next" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange">
			</el-pagination>
		</el-col>

		<!-- 增加字段弹窗 -->
		<el-col :span="24">
			<el-dialog title="增加字段" :visible.sync="dialogVisible" width="30%" :before-close="openOrCloseMode">
				<el-form ref="dicForm" :model="dicForm" label-width="70px">
					<el-form-item label="字段名称">
						<el-input v-model="dicForm.dicValue" placeholder="请输入字段名称" style="width: 300px;" size="mini">
						</el-input>
					</el-form-item>
					<el-form-item label="字段类型">
						<el-select v-model="dicForm.dicTypeId" filterable placeholder="请选择" style="width: 300px;"
							size="mini">
							<el-option v-for="dic in dicTypeList" :key="dic.id" :label="dic.dicType" :value="dic.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="addSubmit('dicForm')">确 定</el-button>
					<el-button @click="openOrCloseMode">取 消</el-button>
				</span>
			</el-dialog>
		</el-col>
	</el-row>
</template>

<script>
	import httpClient from '../../../util/request.js';
	// import http from "../../../../../admin/src/static/untils/request";
	// import global from "../../../../../admin/src/api/global_variable";
	import qs from "qs";
	export default {
		data() {
			return {
				// 分页组件
				pageNum: 1,
				pageSize: 15,
				total: null,
				// table 自适应高度
				tableHeight: window.innerHeight - 300,
				status: '',
				//自定义字段数据组
				customData: [],
				form: {
					dicId: '',
					dicTypeId: '',
					dicTypeName: '',
					dicValue: '',
					created: ''
				},
				// 当前操作的上级ID
				addParamPid: {},
				dialogVisible: false,
				labelType: '',
				dicTypeList: [],
				dicType: '',
				loading: false,
				//增加字段表单
				dicForm: {
					dicId: '',
					dicValue: '',
					dicType: '',
					dicTypeId: '',
					status: 0,
				}
			}
		},
		created() {
			this.getDicTypeAll();
			this.query();
		},
		methods: {
			getDicTypeAll() {
				this.loading = true;
				this.$http.get('/api/source/clrWeekPlan/selectDicType?parentId=2').then(res => {
					var typeList = [{
						id: "",
						dicType: "请选择"
					}];
					this.dicTypeList = typeList.concat(res.data.data);
				});
				this.loading = false;
			},
			// 查询自定义字段列表数据
			query() {
				this.$http.post('/api/source/clrWeekPlan/selectDic?pageNum=' + this.pageNum + '&pageSize=' + this
					.pageSize, {
						status: 0
					}).then(res => {
					this.customData = res.data.data.list;
					this.total = res.data.data.total;
				});
			},
			/**
			 * 删除整条自定义字段数据
			 */
			delCustomData(id, status) {
				this.$confirm('此操作将删除自定义字段, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.post(`/api/source/clrWeekPlan/updateDic`, {
						dicId: id,
						status: status
					}).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '删除成功'
							});
							this.query();
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					}).catch(error => {});
				});
			},
			addSubmit(dicForm) {
				if (!this.dicForm.dicValue.trim() || !this.dicForm.dicTypeId) {
					return this.$message({
						type: "error",
						message: "请填写完整字段信息再提交",
					});
				}
				this.$http.post(`/api/source/clrWeekPlan/queryDicRepeat?dicValue=` + this.dicForm.dicValue).then(res => {
					if (res.data.data !== 0) {
						return this.$message({
							type: 'error',
							message: '字段名称与原数据重复',
						});
					} else {
						this.$refs.dicForm.validate((valid) => {
							if (valid) {
								var form = this.dicForm;
								return this.$http.post('/api/source/clrWeekPlan/insertDic', form).then(
									res => {
										if (res.data.status === 0) {
											this.$message({
												type: 'success',
												message: '添加成功'
											});
											this.dialogVisible = !this.dialogVisible;
											this.query();
										} else {
											this.$message({
												type: 'error',
												message: res.data.msg
											});
										}
									});
							}
						});
					}
				});
			},
			/**
			 * 添加字段
			 */
			addCustom(row) {
				this.resetForm();
				this.addParamPid = row;
				this.openOrCloseMode();
			},
			resetForm() {
				this.dicForm = {
					dicId: '',
					dicValue: '',
					dicType: '',
					dicTypeId: '',
					status: 0,
				}
			},
			//弹框
			openOrCloseMode() {
				this.dialogVisible = !this.dialogVisible;
			},
			// 分页组件
			handleSizeChange() {
				this.pageNum = 1;
				this.query();
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				this.query();
			},
		}
	}
</script>
<style lang="less" scoped>
	/deep/.el-input {
		height: auto;
	}
</style>
